import React from 'react';
import propTypes from 'prop-types';

const RestrictedThreeColumn = props => {
  const item = props.features.map(feature => {
    return (
      <div className="restricted-three-column-section__item col-xs-12 col-sm-6 col-md-3 col-lg-4">
        <img src={feature.imageUrl} />
        <h2>{feature.header}</h2>
        <div
          className="restricted-three-column-section__item__text"
          dangerouslySetInnerHTML={{ __html: feature.content }}
        />
      </div>
    );
  });

  return (
    <div className="content-wrapper">
      <div className="row scalable-content-section restricted-three-column-section">
        {item}
      </div>
    </div>
  );
};

RestrictedThreeColumn.propTypes = {
  imageUrl: propTypes.string.isRequired,
  header: propTypes.string.isRequired,
  content: propTypes.string.isRequired,
};

export default RestrictedThreeColumn;
